import { render, staticRenderFns } from "./message-rating-number.vue?vue&type=template&id=e4200ba2&scoped=true"
import script from "./message-rating-number.vue?vue&type=script&lang=ts"
export * from "./message-rating-number.vue?vue&type=script&lang=ts"
import style0 from "./message-rating-number.vue?vue&type=style&index=0&id=e4200ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4200ba2",
  null
  
)

export default component.exports